import { IBrandOrder } from "@faire/web-api--source/indigofair/data/IBrandOrder";

import { InstantAnswerContext } from "../types";

export const getDeliveredAtDateFromIAContext = (
  context: InstantAnswerContext
) => {
  const { brandOrder, shippingContext } = context;
  return (
    shippingContext?.delivered_at ??
    getDeliveryDateForBrandOrder(brandOrder?.brand_order)
  );
};

const getDeliveryDateForBrandOrder = (brandOrder: IBrandOrder | undefined) => {
  return brandOrder?.delivered_at ?? brandOrder?.shipments[0]?.delivered_at;
};
